// extracted by mini-css-extract-plugin
export default {"cartIcon":"ShoppingCartButton_cartIcon__XFi5K","cartBadge":"ShoppingCartButton_cartBadge__XmXtj"};